export { default as RetryError } from './RetryError';
export { default as CustomFetchApiError } from './CustomFetchApiError';

export const toError = (error: any) => {
    if (!error) {
        return new Error('Original error has no description');
    }

    if (error instanceof Error) {
        return error;
    }

    if (typeof error === 'string') {
        return new Error(error);
    }

    return new Error(JSON.stringify(error));
};

export const errorToJson = (error: Error) => {
    return {
        name: error.name,
        message: error.message,
        stack: error.stack,
    };
};
